<template>
  <AuthLayout :back-to="{ name: 'Login' }" back-label="Back to login">
    <template v-if="!resetLinkSent">
      <form class="form-stack" @submit.prevent="attemptResetRequest()">
        <div class="auth-form-header">
          <h1>Request a new password</h1>
          <p>Enter the email associated with your account and we will send reset instructions.</p>
        </div>

        <InputField
          v-model:value="form.email.value"
          :errors="form.email.errors"
          label-size="small"
          input-text-size="small"
          @blur="form.email.validate()"
          type="email"
          label="Email"
          placeholder="Enter email..."
        />

        <BaseButton block variant="primary" size="md" type="submit" :disabled="!form.isValid">
          Request password reset
        </BaseButton>
      </form>
    </template>

    <template v-else>
      <div class="form-stack">
        <div class="auth-form-header">
          <h1>Check your email</h1>
          <div class="auth-message">
            <p>
              Your request has been submitted. If there is an account associated with the email
              provided, you should receive an email shortly with instructions to reset your
              password.
            </p>
            <p>If you do not see the email in your inbox soon, please check your spam folder.</p>
          </div>
        </div>

        <BaseButton block variant="primary" size="md" @click="router.push({ name: 'Login' })">
          Return to login
        </BaseButton>
      </div>
    </template>
  </AuthLayout>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { RequestPasswordResetForm, UserApi } from '@/services/users/'
import InputField from '@/components/inputs/InputField'
import AuthLayout from '@/components/auth/AuthLayout.vue'

export default {
  name: 'RequestPasswordReset',
  components: {
    InputField,
    AuthLayout,
  },
  setup() {
    const router = useRouter()
    const form = ref(new RequestPasswordResetForm())
    const resetLinkSent = ref(false)

    function handleResetRequestSuccess() {
      resetLinkSent.value = true
    }

    function handleResetRequestFailure(error) {
      alert(error)
    }

    function attemptResetRequest() {
      const unwrappedForm = form.value
      unwrappedForm.validate()
      if (!unwrappedForm.isValid) return

      UserApi.csc
        .requestPasswordReset({ email: unwrappedForm.email.value })
        .then(handleResetRequestSuccess)
        .catch(handleResetRequestFailure)
    }

    return {
      form,
      router,
      attemptResetRequest,
      resetLinkSent,
    }
  },
}
</script>
